// extracted by mini-css-extract-plugin
module.exports = {"heading":"Canvas_heading__1x69h","frame":"Canvas_frame__6euRr"};